// UI
import { CardBody, CardWrapper } from "@/components/Card"
import { Heading } from "@/components/Typography"

// Translation
import { useTrans } from "@/i18n"

/**
 * AllProjectsDefaultRate
 * @returns
 */
export function AllProjectsDefaultRate() {
	const t = useTrans("dashboard")

	return (
		<CardWrapper className="mb-4">
			<CardBody>
				<Heading
					as="h2"
					styleAs="h3"
					className="mb-6 text-center sm:truncate"
				>
					{t("dashboard:default_rate.title")}
				</Heading>
				<p className="mb-6 text-center text-sm sm:truncate">
					{t("dashboard:default_rate.subtitle")}
				</p>

				<div className="grid grid-cols-1 gap-6 md:grid-cols-3">
					<div className="rounded-lg border border-gray-200 bg-white p-6 shadow-xs">
						<div className="mb-4">
							<h3 className="text-lg font-semibold text-gray-900">
								{t(
									"dashboard:default_rate.default_definition.title",
								)}
							</h3>
						</div>
						<p className="text-sm leading-relaxed text-gray-700">
							{t(
								"dashboard:default_rate.default_definition.text",
							)}
						</p>
						<ul className="mt-3 list-disc space-y-1 pl-4 text-sm leading-relaxed text-gray-700">
							<li>
								{t(
									"dashboard:default_rate.default_definition.point1",
								)}
							</li>
							<li>
								{t(
									"dashboard:default_rate.default_definition.point2",
								)}
							</li>
						</ul>
					</div>

					<div className="rounded-lg border border-gray-200 bg-white p-6 shadow-xs">
						<div className="mb-4">
							<h3 className="text-lg font-semibold text-gray-900">
								{t(
									"dashboard:default_rate.unlikeliness_indicators.title",
								)}
							</h3>
						</div>
						<p className="text-sm leading-relaxed text-gray-700">
							{t(
								"dashboard:default_rate.unlikeliness_indicators.text",
							)}
						</p>
					</div>

					<div className="rounded-lg border border-gray-200 bg-white p-6 shadow-xs">
						<div className="mb-4">
							<h3 className="text-lg font-semibold text-gray-900">
								{t(
									"dashboard:default_rate.payment_schedule.title",
								)}
							</h3>
						</div>
						<p className="text-sm leading-relaxed text-gray-700">
							{t("dashboard:default_rate.payment_schedule.text")}
						</p>
					</div>
				</div>
			</CardBody>
		</CardWrapper>
	)
}
